/**
 * Diagnoses Thunks
 * Manages the global diagnoses list (GET, POST, DELETE)
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import * as diagnosesApi from '../api/diagnosesApi';

export const fetchDiagnoses = createAsyncThunk(
  'emr/fetchDiagnoses',
  async (_, { rejectWithValue }) => {
    try {
      const data = await diagnosesApi.fetchDiagnoses();
      // Normalize: [{ _id, name }]
      return data.map((d) => ({ _id: d._id, name: d.name }));
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addDiagnosis = createAsyncThunk(
  'emr/addDiagnosis',
  async (name, { rejectWithValue }) => {
    try {
      const data = await diagnosesApi.addDiagnosis(name);
      // Backend returns { message, _id, name }
      return { _id: data._id, name: data.name || name };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteDiagnosis = createAsyncThunk(
  'emr/deleteDiagnosis',
  async (diagnosisId, { rejectWithValue }) => {
    try {
      await diagnosesApi.deleteDiagnosis(diagnosisId);
      return diagnosisId;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
